module.exports = __webpack_public_path__ + "static/media/landing-vaccine-phone.cd3e59e8.png";